<template>
    <div class="mc-scroll" @scroll="onScroll">
        <slot></slot>
    </div>
</template>
<script>
    import emitter from '@/mixins/emitter.js';
    export default {
        name:'mcScroll',
        mixins:[emitter],
        methods:{
            onScroll(){
                console.log('---sdf---')
                this.broadcast('base-select', 'handleScroll');
                this.broadcast('base-selectbox', 'handleScroll');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/base-scroll.vue